import { Col, Row, Badge, Tabs } from 'antd'
import React, { useState, useEffect } from 'react'
import location_pin from '../assets/images/restaurant/location_red.svg'
import {
  CloseCircleOutlined,
  SearchOutlined,
  ShoppingCartOutlined
} from '@ant-design/icons'
import logo from '../assets/images/logo.png'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { setRestaurant } from '../slices/restaurantCartSlice'
import { useCartNavigation } from '../hooks/useCartNavigation'

export const LocationWrapper = ({
  selectedLGA,
  selectedState,
  handleStateSelect,
  handleLGAChange,
  lagosLga,
  allStates,
  selectLoc,
  businessType,
  searchQuery,
  showCart,
  handleSearchChange
}) => {
  const [isClicked, setIsClicked] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()
  const { id: restaurantId } = useParams()
  const dispatch = useDispatch()
  const { TabPane } = Tabs

  const { handleCartClick, cartCount } = useCartNavigation(
    businessType,
    restaurantId
  )

  const getActiveTab = () => {
    const path = location.pathname
    if (path.startsWith('/restaurant')) return 'restaurant'
    if (path.startsWith('/raw_food')) return 'raw_food'
    if (path.startsWith('/store')) return 'stores'
    return 'restaurant'
  }

  const handleTabChange = key => {
    if (key === 'restaurant') navigate('/restaurant')
    else if (key === 'raw_food') navigate('/raw_food')
    else if (key === 'stores') navigate('/store')
  }

  useEffect(() => {
    if (restaurantId) {
      dispatch(setRestaurant({ restaurantId, businessType }))
    }
  }, [dispatch, restaurantId, businessType])

  const handleLocationWrapperSearch = () => {
    setIsClicked(!isClicked)
  }

  const getSearchPlaceholder = () => {
    const normType = (businessType || "").toLowerCase();
    if (normType === "wholesale" || normType === "raw_food") {
      return selectLoc ? "Search wholesale vendors" : "Search wholesale products";
    }
    if (normType === "store" || normType === "retail" || normType === "stores") {
      return selectLoc ? "Search retail stores" : "Search store items";
    }
    return selectLoc ? "Search restaurants" : "Search restaurant menu";
  };

  return (
    <>
      <div className='wrapperBg sticky top-0 z-50'>
        <Row justify={'middle'} className='h-[100%] pt-5'>
          <Col xs={24}>
            {/* MOBILE */}
            <div className='items-center md:hidden gap-2 justify-around px-10'>
              <div className={` flex items-center justify-between`}>
                <div className={` ${isClicked ? 'hidden' : 'flex'} flex-col `}>
                  {selectLoc ? (
                    <>
                      <div className='flex gap-3'>
                        <span>
                          <img className='' src={location_pin} alt='' />
                        </span>
                        <select
                          className='bg-transparent max-w-fit border-none border-0 outline-0 focus:border-none focus:outline-0 text-3xl'
                          value={selectedLGA}
                          onChange={e => handleLGAChange(e.target.value)}
                        >
                          <option value=''>Select</option>
                          {lagosLga &&
                            lagosLga.length > 0 &&
                            lagosLga.map(lga => (
                              <option key={lga.id} value={lga.name}>
                                {lga.name}
                              </option>
                            ))}
                        </select>
                        <select
                          className='bg-transparent max-w-fit border-none border-0 outline-0 focus:border-none focus:outline-0 text-3xl'
                          value={selectedState?.name || ''}
                          onChange={e => {
                            const state = allStates?.find(item => item.name === e.target.value)
                            if (state) handleStateSelect(state)
                          }}
                        >
                          <option value=''>State</option>
                          {allStates?.map(state => (
                            <option key={state.id} value={state.name}>{state.name}</option>
                          ))}
                        </select>
                      </div>
                      <div className='my-3'>
                        <p className='text-[#959595]'>
                          {selectedLGA + ', Lagos State' || 'Lagos State'}
                        </p>
                      </div>
                    </>
                  ) : (
                    <img src={logo} className={'w-[45%] '} alt='' />
                  )}
                </div>

                <div
                  className={` ${isClicked
                      ? 'flex justify-between border-2 border-[#00000073] w-full rounded-full py-4 px-5 bg-transparent'
                      : ''
                    } `}
                >
                  <input
                    type='text'
                    value={searchQuery || ''}
                    onChange={e =>
                      handleSearchChange && handleSearchChange(e.target.value)
                    }
                    className={` ${isClicked ? 'block' : 'hidden'
                      } w-full bg-transparent focus:outline-none text-3xl`}
                    placeholder={getSearchPlaceholder()}
                  />
                  <div className='flex items-center gap-4'>
                    {isClicked ? (
                      <CloseCircleOutlined
                        style={{ fontSize: '22px' }}
                        onClick={handleLocationWrapperSearch}
                      />
                    ) : (
                      <SearchOutlined
                        style={{ fontSize: '22px' }}
                        onClick={handleLocationWrapperSearch}
                      />
                    )}

                    {showCart && (
                      <Badge count={cartCount} offset={[0, 5]} size='small'>
                        <ShoppingCartOutlined
                          style={{
                            fontSize: '22px',
                            cursor: 'pointer',
                            color: '#000'
                          }}
                          onClick={handleCartClick}
                        />
                      </Badge>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className='hidden md:flex items-center justify-center gap-3 px-8 pb-4'>
              <select
                className='bg-transparent border border-[#00000033] rounded-lg px-3 py-2 outline-none'
                value={selectedState?.name || ''}
                onChange={e => {
                  const state = allStates?.find(item => item.name === e.target.value)
                  if (state) handleStateSelect(state)
                }}
              >
                <option value=''>Select state</option>
                {allStates?.map(state => <option key={state.id} value={state.name}>{state.name}</option>)}
              </select>
              <select
                className='bg-transparent border border-[#00000033] rounded-lg px-3 py-2 outline-none'
                value={selectedLGA || ''}
                onChange={e => handleLGAChange(e.target.value)}
              >
                <option value=''>Select LGA</option>
                {lagosLga?.map(lga => <option key={lga.id} value={lga.name}>{lga.name}</option>)}
              </select>
            </div>
            <Tabs
              activeKey={getActiveTab()}
              onChange={handleTabChange}
              type='card'
              className='support-tabs'
            >
              <TabPane tab='Restaurant' key='restaurant'>
                {/* <RestaurantBusiness user={user} /> */}
                {/* restaurant */}
              </TabPane>
              <TabPane tab='Wholesale' key='raw_food'>
                {/* <RawFoodBusiness user={user} /> */}
                {/* raw food */}
              </TabPane>
              <TabPane tab='Retail' key='stores'>
                {/* <StoreBusiness user={user} /> */}
                {/* store */}
              </TabPane>
            </Tabs>
          </Col>
        </Row>
      </div>
    </>
  )
}
